import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { tableClass } from './styles';
import { inputClass } from '../Input/styles';
import { checkinputClass } from '../Checkbox/styles';
import Td from './Td';
import Expand from './Expand';
import { isFunc } from '../utils/is';
export var ROW_HEIGHT_UPDATE_EVENT = 'ROW_HEIGHT_UPDATE_EVENT_NAME';
var preventClasses = [inputClass('_'), checkinputClass('_'), tableClass('icon-tree-plus'), tableClass('icon-tree-sub')];

var isExpandableElement = function isExpandableElement(el) {
  var tagName = el.tagName;
  if (tagName === 'TD' || tagName === 'TR') return true;
  if (tagName === 'A' || tagName === 'BUTTON' || tagName === 'INPUT') return false;
  if (preventClasses.find(function (c) {
    return el.classList.contains(c);
  })) return false;
  if (!el.parentElement) return false;
  return isExpandableElement(el.parentElement);
};

var DefaultProps = {
  rowClickAttr: ['*'],
  lazy: true
};

var Tr =
/*#__PURE__*/
function (_Component) {
  _inherits(Tr, _Component);

  var _super = _createSuper2(Tr);

  function Tr(props) {
    var _this;

    _classCallCheck(this, Tr);

    _this = _super.call(this, props);
    _this.manualExpand = void 0;
    _this.expandHeight = void 0;
    _this.element = void 0;
    _this.lastRowHeight = void 0;
    _this.lastExpandHeight = void 0;
    _this.lastIndex = void 0;
    _this.lastExpandRender = void 0;
    _this.cachedExpand = void 0;
    _this.manualExpand = false;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleRowClick = _this.handleRowClick.bind(_assertThisInitialized(_this));
    _this.setRowHeight = _this.setRowHeight.bind(_assertThisInitialized(_this));
    _this.setExpandHeight = _this.setExpandHeight.bind(_assertThisInitialized(_this));
    _this.expandHeight = 0;
    return _this;
  }

  _createClass(Tr, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.manualExpand = true;
      this.setRowHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props = this.props,
          hasNotRenderRows = _this$props.hasNotRenderRows,
          dataUpdated = _this$props.dataUpdated,
          columnResizable = _this$props.columnResizable,
          resize = _this$props.resize;

      if (hasNotRenderRows || dataUpdated || prevProps.resize !== resize) {
        var exec = columnResizable ? setTimeout : function (func) {
          return func();
        };
        exec(function () {
          _this2.setRowHeight();
        });
      }
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight(expand) {
      var _this$props2 = this.props,
          setRowHeight = _this$props2.setRowHeight,
          dataUpdated = _this$props2.dataUpdated,
          datum = _this$props2.datum,
          lazy = _this$props2.lazy;
      if (!lazy || !setRowHeight || !this.element) return;

      var _this$element$getBoun = this.element.getBoundingClientRect(),
          height = _this$element$getBoun.height;

      if (Number.isNaN(height)) height = this.lastRowHeight || 0;
      datum.unsubscribe(ROW_HEIGHT_UPDATE_EVENT, this.setRowHeight);

      if (height === 0) {
        datum.subscribe(ROW_HEIGHT_UPDATE_EVENT, this.setRowHeight);
        return;
      }

      if (height === this.lastRowHeight && this.expandHeight === this.lastExpandHeight && !dataUpdated && this.lastIndex === this.props.index) return;
      this.lastRowHeight = height;
      this.lastIndex = this.props.index;
      this.lastExpandHeight = this.expandHeight;
      setRowHeight(height + this.expandHeight, this.props.index, !!expand);
    }
  }, {
    key: "setExpandHeight",
    value: function setExpandHeight(height) {
      this.expandHeight = height;
      this.setRowHeight(this.manualExpand);
    }
  }, {
    key: "getRowClickAttr",
    value: function getRowClickAttr() {
      var rowClickAttr = this.props.rowClickAttr;
      var res = Array.isArray(rowClickAttr) ? rowClickAttr : [];

      if (typeof rowClickAttr === 'string') {
        res.push(rowClickAttr);
      }

      return res.map(function (v) {
        return v === '*' ? '' : v;
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "isFireElement",
    value: function isFireElement(el) {
      var rowClickAttr = this.props.rowClickAttr;
      if (rowClickAttr === true) return true;
      return this.getRowClickAttr().find(function (v) {
        return el.hasAttribute(v);
      });
    }
  }, {
    key: "handleRowClick",
    value: function handleRowClick(e) {
      var _this$props3 = this.props,
          columns = _this$props3.columns,
          rowData = _this$props3.rowData,
          index = _this$props3.index,
          onRowClick = _this$props3.onRowClick,
          externalExpandRender = _this$props3.externalExpandRender,
          externalExpandClick = _this$props3.externalExpandClick,
          onExpand = _this$props3.onExpand,
          originKey = _this$props3.originKey,
          expandRender = _this$props3.expandRender;
      var target = e.target; // business needed #row click to modal drawer

      var fireAttr = this.isFireElement(target);

      if (fireAttr && onRowClick) {
        onRowClick(rowData, index, fireAttr);
        return;
      }

      if (externalExpandRender) {
        var expanded = typeof expandRender === 'function'; // @ts-ignore seems to be useless because expandKeys always undefined

        if (this.props.expandKeys) {
          if (externalExpandClick) externalExpandClick(rowData, !expanded);
        } else {
          onExpand(originKey, expanded ? undefined : externalExpandRender(rowData, index));
        }
      }

      if (isExpandableElement(target)) {
        var el = this.element.querySelector(".".concat(tableClass('expand-indicator')));
        if (el && el !== target && columns.some(function (c) {
          return c.type === 'row-expand';
        })) el.click();
        var matchBlank = this.getRowClickAttr().indexOf('') >= 0;
        if (onRowClick && e.target !== el && matchBlank) onRowClick(rowData, index);
      }
    }
  }, {
    key: "renderExpand",
    value: function renderExpand() {
      var _this$props4 = this.props,
          expandRender = _this$props4.expandRender,
          rowData = _this$props4.rowData;
      if (!expandRender) return null;

      if (this.lastExpandRender !== expandRender && isFunc(expandRender)) {
        this.lastExpandRender = expandRender;
        this.cachedExpand = expandRender(rowData);
      }

      return this.cachedExpand;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          columns = _this$props5.columns,
          data = _this$props5.data,
          rowData = _this$props5.rowData,
          striped = _this$props5.striped,
          index = _this$props5.index,
          expandRender = _this$props5.expandRender,
          offsetLeft = _this$props5.offsetLeft,
          offsetRight = _this$props5.offsetRight,
          hasNotRenderRows = _this$props5.hasNotRenderRows,
          rowClassName = _this$props5.rowClassName,
          treeExpandKeys = _this$props5.treeExpandKeys,
          rowEvents = _this$props5.rowEvents,
          reset = _objectWithoutProperties(_this$props5, ["columns", "data", "rowData", "striped", "index", "expandRender", "offsetLeft", "offsetRight", "hasNotRenderRows", "rowClassName", "treeExpandKeys", "rowEvents"]);

      var other = Object.keys(reset).filter(function (key) {
        return !['format', 'prediction', 'onChange'].includes(key);
      }).reduce(function (r, key) {
        return _objectSpread2(_objectSpread2({}, r), {}, _defineProperty({}, key, reset[key]));
      }, {});
      var tds = [];
      var skip = 0;

      for (var i = 0, c = columns.length; i < c; i++) {
        if (skip > 0) {
          skip -= 1;
        } else if (data[i]) {
          var _columns$i = columns[i],
              _className = _columns$i.className,
              style = _columns$i.style,
              key = _columns$i.key,
              fixed = _columns$i.fixed,
              lastFixed = _columns$i.lastFixed,
              firstFixed = _columns$i.firstFixed,
              type = _columns$i.type,
              render = _columns$i.render,
              onClick = _columns$i.onClick,
              align = _columns$i.align,
              treeColumnsName = _columns$i.treeColumnsName;
          var treeExpand = false;

          if (treeExpandKeys instanceof Map) {
            treeExpand = treeExpandKeys.has(other.originKey);
          }

          var td =
          /*#__PURE__*/
          React.createElement(Td, Object.assign({}, other, {
            expanded: typeof expandRender === 'function',
            key: key,
            treeExpand: treeExpand,
            treeExpandShow: !!treeColumnsName,
            type: type,
            expandClick: onClick,
            className: _className,
            style: style,
            fixed: fixed,
            firstFixed: firstFixed,
            lastFixed: lastFixed,
            align: align,
            render: render // @ts-ignore  这儿重复了
            ,
            index: index
          }, data[i], {
            offsetLeft: offsetLeft,
            offsetRight: offsetRight
          }));
          tds.push(td);
          if (data[i].colSpan) skip = data[i].colSpan - 1;
        }
      }

      var className = tableClass('normal', striped && (index % 2 === 1 ? 'even' : 'odd'));

      if (rowClassName) {
        className = classnames(className, rowClassName(rowData, index));
      }

      var mc = classnames(className, other.datum.check(rowData) && tableClass('selected'));
      var result = [
      /*#__PURE__*/
      React.createElement("tr", Object.assign({
        key: "0"
      }, rowEvents, {
        onClick: this.handleRowClick,
        className: mc,
        ref: this.bindElement
      }), tds)];

      if (expandRender) {
        result.push(
        /*#__PURE__*/
        React.createElement(Expand, {
          key: "1",
          setExpandHeight: this.setExpandHeight,
          colSpan: columns.length
        }, this.renderExpand()));
      }

      return result;
    }
  }]);

  return Tr;
}(Component);

Tr.displayName = 'ShineoutTr';
Tr.defaultProps = DefaultProps;
export default Tr;